import React from 'react';
import {
  useProvidedTranslations,
} from '../../context';
import LayoutNav from '../LayoutNav';
import Seguros from './index';

const cfg = {
  i18nKey: 'dash.seguros',
};

const SegurosWithLayout = () => {
  const translations = useProvidedTranslations();

  return (
    <LayoutNav title={translations.formatMessage(`${cfg.i18nKey}.header`)}>
      <Seguros />
    </LayoutNav>
  );
};

export default SegurosWithLayout;
